
/**
 * @class MediaQueryListModel
 * @description simple model for our media query list
 */
export default class MediaQueryListModel {
  /**
   * @method constructor
   * @description initialize a new instance of MediaQueryListModel
   * @param {String} type the type of media query
   * @param {String} name the name of the media query
   * @param {String} mediaQuery the actual media query String
   * @param {Number} width the minimum width of the media query
   * @returns {Object}
   */
  constructor(type, name, mediaQuery, width) {
    this.type = type;
    this.name = name;
    this.mediaQuery = mediaQuery;

    if (width) {
      this.width = width;
    }
  }
}
